import React from 'react';
import { Bot } from 'lucide-react';

// Provider logos live under public/icons/model_icons (same set the Integrations
// panel uses, so a provider renders with the identical brand mark everywhere).
export const PROVIDER_ICON = {
  openai: '/icons/model_icons/openai.svg',
  anthropic: '/icons/model_icons/anthropic.png',
  gemini: '/icons/model_icons/gemini.png',
  google: '/icons/model_icons/gemini.png',
  mistral: '/icons/model_icons/mistralai.png',
  fireworks: '/icons/model_icons/fireworksai.png',
  groq: '/icons/model_icons/groq.png',
  deepseek: '/icons/model_icons/deepseek.png',
  xai: '/icons/model_icons/grok.png',
  azure: '/icons/model_icons/azureai.png',
  azure_openai: '/icons/model_icons/azureai.png',
  vertex_ai: '/icons/model_icons/vertexai.png',
  jev: '/icons/model_icons/typesafe.png',
  trodo: '/trodologo.svg',
  bedrock: '/icons/model_icons/bedrock.png',
};

const PROVIDER_LOGO_SCALE = { azure_openai: 1.35, azure: 1.35 };
const PROVIDER_NEEDS_WHITE_BG = new Set(['openai', 'xai', 'deepseek']);

export default function ProviderLogo({ provider, size = 18 }) {
  const src = PROVIDER_ICON[provider];
  if (!src) {
    return (
      <span
        style={{
          width: size, height: size,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          border: '1px solid var(--border-default)', borderRadius: '50%', flexShrink: 0,
        }}
      >
        <Bot style={{ width: size - 6, height: size - 6, color: 'var(--text-muted)' }} />
      </span>
    );
  }
  const scale = PROVIDER_LOGO_SCALE[provider] || 1;
  const needsWhiteBg = PROVIDER_NEEDS_WHITE_BG.has(provider);
  return (
    <span
      style={{
        width: size, height: size, display: 'inline-flex',
        alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        borderRadius: '50%',
        background: needsWhiteBg ? '#ffffff' : 'transparent',
        padding: needsWhiteBg ? 2 : 0,
        boxSizing: 'content-box',
      }}
    >
      <img
        src={src}
        alt=""
        style={{
          width: size - (needsWhiteBg ? 4 : 0),
          height: size - (needsWhiteBg ? 4 : 0),
          objectFit: 'contain',
          transform: scale === 1 ? undefined : `scale(${scale})`,
          transformOrigin: 'center',
        }}
      />
    </span>
  );
}
